// import api from "@/plugins/api";
import { getToken } from "@saas/service-api/src/plugins/auth";
import Vue from "vue";
import store from "@saas/store/src";
import { Message } from "element-ui";
import { weChatShare } from "@saas/service-api/src/index";
import { getMoguoCdnUrl } from "./assets";
/*
  手机号校验
  @param number: 手机号  isReg:是否检验手机号规则
*/
export function vailPhone(number, isReg = true) {
  let flag = false;
  const myreg = /^1[3456789]{1}\d{9}$/;
  if (number.length !== 11) {
    flag = false;
  } else if (isReg && !myreg.test(number)) {
    flag = false;
  } else {
    flag = true;
  }
  return flag;
}

export function vailPassWord(str) {
  let flag = false;
  const myreg = /(?=.*\d)(?=.*[a-z])(?=.*[A-Z])/;
  if (str.length < 8 || str.length > 40) {
    flag = false;
  } else if (!myreg.test(str)) {
    flag = false;
  } else {
    flag = true;
  }
  return flag;
}

export function parse(search) {
  const searchStr = decodeURIComponent(search);
  if (searchStr) {
    const result = {};
    const arr = searchStr.split("&");
    for (let i = 0; i < arr.length; i++) {
      const [key, value] = arr[i].split("=");
      result[key] = value;
    }
    return result;
  } else {
    return {};
  }
}

export function isMobile() {
  return /Android|webOS|iPhone|iPod|iPad|BlackBerry/i.test(navigator.userAgent);
}

export function isH5() {
  return document.body.clientWidth < 768;
}

export function isPad() {
  return document.body.clientWidth < 1140;
}
export function isPadApp(userAgent) {
  const ua = userAgent || navigator.userAgent;
  return ua.toLowerCase().indexOf("app-pad") !== -1;
}
export function isWeChat() {
  return navigator.userAgent.toLowerCase().indexOf("micromessenger") !== -1;
}
export function isQQ() {
  let sUserAgent = navigator.userAgent.toLowerCase();
  if (sUserAgent.match(/QQ/i) == "qq") {
    return true;
  } else {
    return false;
  }
}

export function isAndroid() {
  return /android|linux/.test(navigator.userAgent.toLowerCase());
}

export function isIOS() {
  return /iphone|ipad|ipod/.test(navigator.userAgent.toLowerCase());
}

export function isHXApp() {
  return /mgyk-ios-app|mgyk-android-app/i.test(
    navigator.userAgent.toLocaleLowerCase()
  );
}

// 是否是小程序
export function isMini() {
  console.log(window.__wxjs_environment === "miniprogram"); // true
  return window.__wxjs_environment === "miniprogram";
  // return /micromessenger|arkweb|miniProgram/i.test(
  //   navigator.userAgent.toLocaleLowerCase()
  // );
}
export const isMac = () => {
  return /macintosh|mac os x|macintel/i.test(navigator.userAgent.toLowerCase());
};

export function isMGAppInPad() {
  return /mgyk-ios-app-pad|mgyk-android-app-pad/i.test(
    navigator.userAgent.toLocaleLowerCase()
  );
}

export function mgAppVersion() {
  // let a =
  //   "Mozilla/5.0(iPhone;CPUiPhone OS 15_5 like Mac OS X) AppleWebKit/605.1.15 (KHTML, like Gecko)Mobile/15E148 mgyk-ios-app/1.8.0-3";
  const pattern =
    /(mgyk-ios-app-pad|mgyk-android-app-pad|mgyk-ios-app|mgyk-android-app)/g;

  const matches = navigator.userAgent.toLocaleLowerCase().match(pattern);
  // const matches = a.match(pattern);
  if (matches?.length) {
    let name = matches[0] + "/";
    let version = navigator.userAgent.toLocaleLowerCase().split(name)[1];
    if (version.includes("-")) {
      version = version.split("-")[0];
    }
    return version;
  } else {
    return false;
  }
}

// app版本号比较
export function compareVersion(v2) {
  let v1 = mgAppVersion();
  console.log(v1, "app-version=========");
  // 未获取到版本信息
  if (!v1) return false;
  v1 = v1.split(".");
  v2 = v2.split(".");
  const len = Math.max(v1.length, v2.length);

  while (v1.length < len) {
    v1.push("0");
  }
  while (v2.length < len) {
    v2.push("0");
  }

  for (let i = 0; i < len; i++) {
    const num1 = parseInt(v1[i]);
    const num2 = parseInt(v2[i]);

    if (num1 > num2) {
      return 1;
    } else if (num1 < num2) {
      return -1;
    }
  }
  // 相等
  return 0;
}

// 解析userAgent 中的信息
export function parseUserAgent() {
  let userAgent = navigator.userAgent;
  console.log(userAgent, "userAgent===========");

  const result = {};
  const parts = [];
  let currentPart = "";
  let inParentheses = false;

  for (let i = 0; i < userAgent.length; i++) {
    const char = userAgent[i];
    if (char === "(") {
      inParentheses = true;
      currentPart += char;
    } else if (char === ")") {
      inParentheses = false;
      currentPart += char;
    } else if (char === " " && !inParentheses) {
      if (currentPart) {
        parts.push(currentPart);
        currentPart = "";
      }
    } else {
      currentPart += char;
    }
  }
  if (currentPart) {
    parts.push(currentPart);
  }

  parts.forEach((part) => {
    const index = part.indexOf("/");
    if (index !== -1) {
      const key = part.slice(0, index);
      const value = part.slice(index + 1);
      result[key] = value;
    }
  });

  console.log(result, "userAgent-result===========");

  return result;
}

// 复制
export function clipboard(content, callback) {
  var input = document.createElement("input");
  input.setAttribute("readonly", "readonly");
  input.setAttribute("value", content);
  document.body.appendChild(input);
  input.select();
  input.setSelectionRange(0, 9999);
  if (document.execCommand) {
    document.execCommand("copy");
    callback();
  }
  document.body.removeChild(input);
}
export function copyText(text) {
  return new Promise((resolve, reject) => {
    if (!navigator.clipboard) {
      const input = document.createElement("textarea");
      // const input = document.createElement('input')
      document.body.appendChild(input);
      input.value = text;
      // input.setAttribute('value', text)
      input.select();
      if (document.execCommand("copy")) {
        document.execCommand("copy");
        document.body.removeChild(input);
        resolve();
      } else {
        document.body.removeChild(input);
        reject();
      }
    } else {
      // 使用 Clipboard API
      navigator.clipboard
        .writeText(text)
        .then(() => {
          resolve();
        })
        .catch(() => {
          reject();
        });
    }
  });
}

export function isMqq() {
  return navigator.userAgent.toLowerCase().indexOf(" qq/") !== -1;
}

export function pageShare(wx, params = {}) {
  if (isMobile()) {
    if (isWeChat() || isMqq()) {
      const defaults = {
        url: window.location.href,
        title: `魔果云课 AI教育工具-专业的知识分享和AI在线教育平台`,
        desc: ``,
        imgUrl: getMoguoCdnUrl("/cdn/logo.png"),
      };
      let data = Object.assign({}, defaults, params);
      console.log(data, "data===");
      weChatShare(data).then(
        (res) => {
          if (res.code === 1) {
            data = Object.assign({}, data, res.data);
            console.log(data);
            weChatShareFn(wx, data);
          } else {
            console.log(res.data.msg);
          }
        },
        (_) => {
          console.log(_);
        }
      );
    }
  }
}

export function weChatShareFn(wx, params) {
  wx.config({
    // debug: window.location.host.includes("zhixinoj.com"),
    debug: false,
    appId: params.app_id,
    timestamp: params.timestamp,
    nonceStr: params.nonce_str,
    signature: params.signature,
    jsApiList: [
      "onMenuShareTimeline",
      "onMenuShareAppMessage",
      "onMenuShareQQ",
      "onMenuShareQZone",
    ],
  });
  wx.error(function (res) {
    console.log(res);
  });
  wx.ready(function () {
    wx.onMenuShareTimeline(params);
    wx.onMenuShareAppMessage(params);
    wx.onMenuShareQQ(params);
    wx.onMenuShareQZone(params);
  });
}

/*
  获取两个日期中间的日期
  @param stime: 开始日期("2022-07-07") 
         etime: 结束日期("2022-08-04")
*/
export function getDiffDate(stime, etime) {
  //初始化日期列表，数组
  var diffdate = new Array();
  var i = 0;
  //开始日期小于等于结束日期,并循环
  while (stime <= etime) {
    diffdate[i] = stime;

    //获取开始日期时间戳
    var stime_ts = new Date(stime).getTime();
    // console.log("当前日期：" + stime + "当前时间戳：" + stime_ts);

    //增加一天时间戳后的日期
    var next_date = stime_ts + 24 * 60 * 60 * 1000;

    //拼接年月日，这里的月份会返回（0-11），所以要+1
    var next_dates_y = new Date(next_date).getFullYear() + "-";
    var next_dates_m =
      new Date(next_date).getMonth() + 1 < 10
        ? "0" + (new Date(next_date).getMonth() + 1) + "-"
        : new Date(next_date).getMonth() + 1 + "-";
    var next_dates_d =
      new Date(next_date).getDate() < 10
        ? "0" + new Date(next_date).getDate()
        : new Date(next_date).getDate();

    stime = next_dates_y + next_dates_m + next_dates_d;

    //增加数组key
    i++;
  }
  return diffdate;
}

// 处理视频时长
export function handleDuration(duration) {
  if (duration) {
    const hours = Math.floor(duration / 3600); // 计算小时
    const minutes = Math.floor((duration % 3600) / 60); // 计算分钟
    let str = "";
    if (hours) {
      str += `${hours}小时`;
    }
    if (minutes) {
      str += `${minutes}分钟`;
    }
    if (!str) {
      str = `${duration}秒`;
    }
    return str;
  } else {
    return "";
  }
}

// 根据起始时间计算时长
export function getDurationByStartEndTime(startTime, endTime) {
  let duration = endTime - startTime;
  const hours = Math.floor(duration / 3600); // 计算小时
  const minutes = Math.floor((duration % 3600) / 60); // 计算分钟
  const second = Math.floor(duration % 60); // 计算秒
  return {
    hours,
    minutes,
    second,
  };
}

function closeSaasLoading() {
  clearTimeout(window.loadingTimer);
  if (!window.saasLoading) return;
  window.saasLoading.close();
  window.saasLoading = null;
}

/// 进入直播间
export async function joinLiveRoom(liveParams) {
  // const { userid, token, classid, courseid, lessonid } = liveParams;
  // 非生产环境添加 alpha 场景标识
  if (process.env.VUE_APP_ENV !== 'production') {
    liveParams = {
      ...liveParams,
      scene: "alpha",
      // 本地调试
      // debugjs: "http://localhost:5500/dist/saas-room.umd.js",
      // debugcss: "http://localhost:5500/dist/saas-room.css",
    };
  }
  // 推流模式（mode===3）参数处理（只有老师才添加rtmp=1参数）
  if (liveParams.mode === 3 && liveParams.isTeacher) {
    liveParams.rtmp = 1;
  }
  delete liveParams.mode;
  delete liveParams.isTeacher;
  delete liveParams.isAssistant;
  console.log("=== joinLiveRoom === ", liveParams);
  let isElectron = window.isElectron ?? false;
  if (isElectron) {
    // 判断是否在直播间
    let inRome = await window.ipcRenderer.invoke("judge-in-live-room", {
      showLiveTips: false,
    });
    console.log("=== joinLiveRoom-inRome === ", inRome);
    if (inRome) {
      // 当前直播间-课程id
      const liveRoomInfo =
        (await window.ipcRenderer
          .invoke("get-current-live-room-info")
          .catch(() => null)) || {};
      let currentLessonId =
        liveRoomInfo.lessonId ?? store.state.classReminder?.lessonId;
      const targetLessonId = Number(liveParams.lessonid);
      const normalizedCurrentLessonId = Number(currentLessonId);
      const isSameLesson =
        Number.isFinite(targetLessonId) &&
        Number.isFinite(normalizedCurrentLessonId) &&
        targetLessonId === normalizedCurrentLessonId;
      console.log("=== joinLiveRoom-current-lesson-check === ", {
        targetLessonId: liveParams.lessonid,
        targetLessonIdType: typeof liveParams.lessonid,
        currentLessonId,
        currentLessonIdType: typeof currentLessonId,
        liveRoomInfo,
        isSameLesson,
      });
      // 关闭loading
      if (isSameLesson) {
        // 显示当前直播间
        window.ipcRenderer.send("show-live-room-win");
        Vue.prototype.$classBell.play();
      } else {
        // 提示
        Message.warning("暂不支持直接跳转，请离开当前直播间后再进入目标直播间");
      }
      closeSaasLoading();
    } else {
      const { lessonid, courseid } = liveParams;
      window.createNewWin({
        key: "custom-live-room",
        url: `/live/${lessonid}/${courseid}`,
        preloadFile: "live-room",
        maximize: true,
        transparent: true,
        hasShadow: false,
        params: {
          lesson_id: lessonid,
          course_id: courseid,
        },
      });
      Vue.prototype.$classBell.play();
    }
  } else {
    liveParams.isweb = 1;
    var event = new Event("join-live-room-over");
    window.dispatchEvent(event);
    Vue.prototype.$classBell.play();
    const url =
      process.env.VUE_APP_SAAS_WEB_URL +
      "/live/" +
      liveParams.lessonid +
      "/" +
      liveParams.courseid;
    if (isWeChat()) {
      window.location.href = url;
    } else {
      setTimeout(() => {
        window.open(url, "_blank");
      }, 0);
    }
  }
}

// 过万处理
export function million(value) {
  let num;
  if (value > 9999) {
    //大于9999显示x.xx万
    num = Math.floor(value / 1000) / 10 + "万";
  } else {
    num = value;
  }
  return num;
}
// window.open 下载文件
export function downloadFileByWindowOpen(url, query = {}) {
  const params = new URLSearchParams({
    ...query,
    token: getToken(),
  }).toString();
  const href = `${url}?${params}`;
  const a = document.createElement("a");
  a.href = href;
  a.style.display = "none";
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
}

// 拼接url参数
export function appendQueryParamsToUrl(baseUrl, params) {
  const queryString = Object.keys(params)
    .map(
      (key) => `${encodeURIComponent(key)}=${encodeURIComponent(params[key])}`
    )
    .join("&");
  return `${baseUrl}?${queryString}`;
}

// 图片拼接域名
export function handleImageUrl(url) {
  if (!url) return "";
  if (url.startsWith("http")) {
    return url;
  } else {
    return `${process.env.VUE_APP_CDN_URL}${url}`;
  }
}

// 获取未来离现在最近的整5分钟的时间戳
export function getNextFiveMinutes() {
  const now = new Date();
  const currentMinutes = now.getMinutes();
  const minutesPastLastFive = currentMinutes % 5;

  // 如果当前时间距离上一个整5分钟不足5分钟，则直接取下一个5分钟的整点
  const minutesToAdd = minutesPastLastFive === 0 ? 5 : 5 - minutesPastLastFive;
  now.setMinutes(now.getMinutes() + minutesToAdd, 0, 0); // 设置秒和毫秒为0
  console.log(now, "getNextFiveMinutes");
  return now.getTime();
}

export function isWebPageInElectron() {
  let saasWebHostname = "";
  try {
    saasWebHostname = new URL(process.env.VUE_APP_SAAS_WEB_URL).hostname;
  } catch (error) {
    saasWebHostname = "";
  }
  const protocol = window.location.protocol;
  return (
    window.isElectron &&
    (protocol === "http:" || protocol === "https:") &&
    window.location.hostname &&
    window.location.hostname === saasWebHostname
  );
}

// 复制当前页链接
export function copyPageUrl(msg = "已复制课程链接，粘贴即可分享", url) {
  let content = null;
  if (url) {
    content = url;
  } else {
    content = window.location.href;
  }
  const _this = this;
  clipboard(content, () => {
    Vue.prototype.$showToast(msg || "已复制课程链接，粘贴即可分享");
  });
}

// 返回文件图片
export function fileImagebyFileName(fileName) {
  if (!fileName) return;
  let file_ext = fileName.split(".").slice(-1)[0].toLowerCase();
  if (["doc", "docx"].includes(file_ext)) {
    return require("@saas/pages/assets/images/chat/doc.png");
  } else if (["pdf"].includes(file_ext)) {
    return require("@saas/pages/assets/images/chat/pdf.png");
  } else if (["ppt", "pptx"].includes(file_ext)) {
    return require("@saas/pages/assets/images/chat/ppt.png");
  } else if (["xlsx", "xls"].includes(file_ext)) {
    return require("@saas/pages/assets/images/chat/xls.png");
  } else if (["txt"].includes(file_ext)) {
    return require("@saas/pages/assets/images/chat/txt.png");
  } else if (["mp3", "wav", "aac", "flac", "m4a", "ogg"].includes(file_ext)) {
    return require("@saas/pages/assets/images/chat/audio.png");
  } else if (
    [
      "mp4",
      "avi",
      "wmv",
      "mov",
      "flv",
      "rmvb",
      "3gp",
      "m4v",
      "mkv",
      "webm",
    ].includes(file_ext)
  ) {
    return require("@saas/pages/assets/images/chat/video.png");
  } else if (["rar"].includes(fileName)) {
    return require("@saas/pages/assets/images/chat/rar.png");
  } else if (["zip"].includes(fileName)) {
    return require("@saas/pages/assets/images/chat/zip.png");
  } else if (["exe", "ipa", "apk", "dmg"].includes(fileName)) {
    return require("@saas/pages/assets/images/chat/exe.png");
  } else if (["html", "htm", "mht"].includes(fileName)) {
    return require("@saas/pages/assets/images/chat/html.png");
  } else if (
    [
      "jpg",
      "jpeg",
      "png",
      "gif",
      "bmp",
      "webp",
      "svg",
      "ico",
      "tiff",
      "tif",
    ].includes(file_ext)
  ) {
    return require("@saas/pages/assets/images/chat/img.png");
  } else {
    return require("@saas/pages/assets/images/chat/unknown.png");
  }
}

// 文件大小转换
export const handleFilesize = (size, n = 1) => {
  //格式化数字类型,保留小数点后几位,非四舍五入
  //size:值
  //n:保留位数
  var units = new Array("B", "KB", "MB", "GB", "TB", "PB");
  var mod = 1024.0;
  var i = 0;
  while (size >= mod) {
    size /= mod;
    i++;
  }
  return formatNum(size, n) + units[i];
};

const formatNum = (size, n = 1) => {
  //格式化数字类型,保留小数点后几位,非四舍五入
  //size:值
  //n:保留位数
  var sizeStr = size.toString();
  if (sizeStr.lastIndexOf(".") > -1)
    return sizeStr.substring(0, sizeStr.toString().indexOf(".") + 1 + n);
  else return sizeStr;
};

// 分割价格（价格需为单位分）
export const splitPrice = (price) => {
  let [integer, decimal] = (Number(price) / 100).toString().split(".");
  if (decimal) {
    return `<span class="unit">￥</span><span class="integer">${integer}.</span><span class="decimal">${decimal}</span>`;
  } else {
    return `<span class="unit">￥</span><span class="integer">${integer}</span>`;
  }
};

// 获取整小时的时间戳
export function getHourTimestamp() {
  const now = new Date();
  now.setMinutes(0, 0, 0); // 设置分钟、秒和毫秒为0
  return now.getTime();
}

// 富文本空校验
export function removeOuterHTMLTags(htmlString) {
  if (htmlString) {
    return htmlString.replace(/<(?!img\b)[^>]*>/g, "").trim();
  } else {
    return "";
  }
}

//base64转file
export function convertBase64ToFile(data, name) {
  if (data) {
    const base64String = data.split(",")[1]; // 去掉数据 URI 的前缀
    const byteCharacters = atob(base64String);
    const byteNumbers = new Array(byteCharacters.length);
    for (let i = 0; i < byteCharacters.length; i++) {
      byteNumbers[i] = byteCharacters.charCodeAt(i);
    }
    const byteArray = new Uint8Array(byteNumbers);
    const blob = new Blob([byteArray], { type: "image/png" }); // 根据实际情况调整 MIME 类型
    return new File([blob], name, { type: "image/png" });
  } else {
    return null;
  }
}

// 格式化时间 00:00:00 ，不够小时不显示
export function formatTimeBySeconds(seconds) {
  const hours = Math.floor(seconds / 3600);
  const minutes = Math.floor((seconds % 3600) / 60);
  const secs = Math.floor(seconds % 60);
  let timeStr = `${minutes < 10 ? "0" + minutes : minutes}:${secs < 10 ? "0" + secs : secs
    }`;
  if (hours) {
    timeStr = `${hours < 10 ? "0" + hours : hours}:${timeStr}`;
  }
  return timeStr;
}

// 格式化时间 00:00:00
export function formatTimeBySecond(second) {
  const hours = Math.floor(second / 3600);
  const minutes = Math.floor((second % 3600) / 60);
  const secs = Math.floor(second % 60);
  return `${hours < 10 ? "0" + hours : hours}:${minutes < 10 ? "0" + minutes : minutes
    }:${secs < 10 ? "0" + secs : secs}`;
}

// 提取笔记大纲
export function extractTextFromHtml(html) {
  const parser = new DOMParser();
  const doc = parser.parseFromString(html, "text/html");

  let haveAIBlock = false;

  function extractText(node) {
    // 处理公式元素
    if (
      node.nodeType === Node.ELEMENT_NODE &&
      node.getAttribute("data-w-e-type") === "formula"
    ) {
      return "[公式]";
    }

    // 处理标记块元素
    if (
      node.nodeType === Node.ELEMENT_NODE &&
      node.getAttribute("data-w-e-type") === "markblock"
    ) {
      return "[标记]";
    }

    // 处理AI问答块元素
    if (
      node.nodeType === Node.ELEMENT_NODE &&
      node.getAttribute("data-w-e-type") === "qablock"
    ) {
      haveAIBlock = true;
      return "[AI问答]";
    }

    // 处理图片元素
    if (
      node.nodeType === Node.ELEMENT_NODE &&
      node.tagName.toLowerCase() === "img"
    ) {
      return "[图片]";
    }

    // 处理文本节点
    if (node.nodeType === Node.TEXT_NODE) {
      return node.textContent;
    }

    // 递归处理子节点
    let result = "";
    for (let child of node.childNodes) {
      result += extractText(child);
    }

    // 如果是块级元素，添加换行符
    // if (node.nodeType === Node.ELEMENT_NODE) {
    //   const display = window.getComputedStyle(node).display;
    //   if (
    //     ["block", "table", "div", "p", "pre", "li", "ol", "ul"].includes(
    //       display
    //     )
    //   ) {
    //     result += "\n";
    //   }
    // }
    return result;
  }

  // 提取文本后去除所有空白字符
  return { text: extractText(doc.body).replace(/\s+/g, ""), haveAIBlock };
}

export function getLessonIdFromReplayWinUrl(url) {
  // 1. 提取哈希部分
  const hashIndex = url.indexOf("#");
  if (hashIndex === -1) return null;
  const hashPart = url.slice(hashIndex + 1);
  // 2. 去除查询参数（? 后的部分）
  const pathPart = hashPart.split("?")[0];
  // 3. 分割路径并过滤空字符串
  const params = pathPart.split("/").filter((p) => p !== "");
  // 4. 确保路径格式正确（至少包含 replay/a/b/c 结构）
  if (params.length < 3 || params[0] !== "replay") return null; // 校验路径格式
  return Number(params[3]); // 返回 c 的值
}

/**
 * 处理图片URL，判断是否为动图，非动图则添加压缩参数
 * @param {string} url 图片URL
 * @param {number} width 压缩后的宽度，默认为640
 * @return {string} 处理后的URL
 */
export function processImageUrl(url, width = 640) {
  if (!url) return "";

  // 判断是否为动图（GIF格式）
  const isAnimated = /\.(gif|webp|apng)$/i.test(url);

  // 如果已经包含压缩参数，或者是动图，则不添加压缩参数
  if (isAnimated || url.includes("?imageView2")) {
    return url;
  }
  // 判断是否已经有参数了，
  if (url.includes("?")) {
    return `${url}&imageView2/0/w/${width}`;
  }
  // 非动图添加压缩参数
  return `${url}?imageView2/0/w/${width}`;
}

export function closeWindow() {
  if (window.isElectron) {
    window.close();
  } else {
    window.close();
    setTimeout(function () {
      window.location.href = "/";
    }, 100);
  }
}

/**
 * Parse the time to string
 * @param {(Object|string|number)} time
 * @param {string} cFormat
 * @returns {string | null}
 */
export function parseTime(time, cFormat) {
  if (arguments.length === 0 || !time) {
    return null;
  }
  const format = cFormat || "{y}-{m}-{d} {h}:{i}:{s}";
  let date;
  if (typeof time === "object") {
    date = time;
  } else {
    if (typeof time === "string") {
      if (/^[0-9]+$/.test(time)) {
        // support "1548221490638"
        time = parseInt(time);
      } else {
        // support safari
        // https://stackoverflow.com/questions/4310953/invalid-date-in-safari
        time = time.replace(new RegExp(/-/gm), "/");
      }
    }

    if (typeof time === "number" && time.toString().length === 10) {
      time = time * 1000;
    }
    date = new Date(time);
  }
  const formatObj = {
    y: date.getFullYear(),
    m: date.getMonth() + 1,
    d: date.getDate(),
    h: date.getHours(),
    i: date.getMinutes(),
    s: date.getSeconds(),
    a: date.getDay(),
  };
  const time_str = format.replace(/{([ymdhisa])+}/g, (result, key) => {
    const value = formatObj[key];
    // Note: getDay() returns 0 on Sunday
    if (key === "a") {
      return ["日", "一", "二", "三", "四", "五", "六"][value];
    }
    return value.toString().padStart(2, "0");
  });
  return time_str;
}

// 根据文件名判断是否是图片
export function isImage(fileName) {
  const reg = /(\.jpg|\.jpeg|\.png|\.gif|\.bmp)$/i;
  return reg.test(fileName);
}
// 根据文件名判断是否是视频
export function isVideo(fileName) {
  const reg =
    /(\.mp4|\.avi|\.rmvb|\.wmv|\.flv|\.mov|\.mpg|\.mpeg|\.rm|\.asf|\.3gp|\.mkv|\.3g2|\.h264|\.m4v|\.mj2|\.ogg|\.ogv|\.qt|\.vob|\.webm|\.f4v)$/i;
  return reg.test(fileName);
}
// 根据文件名判断是否是文档
export function isDoc(fileName) {
  const reg = /(\.pdf|\.doc|\.docx|\.ppt|\.pptx|\.xls|\.xlsx)$/i;
  return reg.test(fileName);
}
